import { Component } from '@angular/core';

import { ValidationError } from '../../../models/validation/validation-error';
import { BaseConfirmationDialogComponent } from '../base-confirmation-dialog.component';

@Component({
  selector: 'boi-affordability-warning-dialog',
  templateUrl: './affordability-warning-dialog.component.html',
  styleUrls: ['./affordability-warning-dialog.component.scss']
})
export class AffordabilityWarningDialogComponent extends BaseConfirmationDialogComponent<Array<ValidationError>> {
  constructor() {
    super();
  }
}
